<template>
  <form id="terminate-card-form" method="post" class="filter-datatable" @submit.prevent="doFilter">
    <div class="row">
      <div class="small-12 medium-6 columns">
        <engraved-id id="engravedId"
                     :$v="$v.filterEngravedId"
                     :value="filter.engravedId"
                     :custom-container-classes="['gridelement', 'formsectioncompound']"
                     :label="$t('orderTerminateCard.filterForm.engravedId')"
                     :show-part-validation-errors="false"
                     name="engravedId"
                     @input="setFilterEngravedId"/>
      </div>
      <div class="small-12 medium-6 columns">
        <input-field id="cardHolderDetails"
                     :$v="$v.filterCardHolderDetails"
                     :value="filter.cardHolderDetails"
                     :custom-container-classes="['gridelement', 'formsectioncompound']"
                     :label="$t('orderTerminateCard.filterForm.cardHolderDetails')"
                     name="cardHolderDetails"
                     @input="setFilterCardHolderDetails"/>
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <input-field id="combinedAscriptions"
                     :$v="$v.filterCombinedAscriptions"
                     :value="filter.combinedAscriptions"
                     :custom-container-classes="['gridelement', 'formsectioncompound']"
                     :label="$t('orderTerminateCard.filterForm.combinedAscriptions')"
                     name="combinedAscriptions"
                     @input="setFilterCombinedAscriptions"/>
      </div>
      <div class="small=12 medium-6 columns">
        <div id="filter" class="wm-field-input">
          <input :value="this.$t('generic.search')" type="submit" class="confirmation">
        </div>
        <div id="resetFilter" class="wm-field-input">
          <input :value="this.$t('generic.resetFilter')" type="submit" class="alt" @click="resetFilter">
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import InputField from './fields/InputField'
import {RESET_FILTER, SET_FILTER_PAIR} from '../../store/modules/order-terminate-card/mutation-types'
import EngravedId from './fields/EngravedId'
import {buildFilterPair} from '../../types/filter-pair'
import {FILTER_CARD_HOLDER_DETAILS, FILTER_COMBINED_ASCRIPTIONS, FILTER_ENGRAVED_ID} from '../../types/company-cards-filter'

export default {
  name: 'TerminateCardFilterForm',
  components: {EngravedId, InputField},
  computed: {
    ...mapState('orderTerminateCard', {
      filter: state => state.filter
    })
  },
  validations () {
    return {
      filterEngravedId: {},
      filterCardHolderDetails: {},
      filterCombinedAscriptions: {}
    }
  },
  methods: {
    ...mapMutations('orderTerminateCard', {
      'setFilterPair': SET_FILTER_PAIR,
      'resetFilterMutation': RESET_FILTER
    }),
    ...mapActions('orderTerminateCard', [
      'resetCurrentPageNumber'
    ]),
    doFilter () {
      this.resetCurrentPageNumber()
      this.$emit('filter')
    },
    resetFilter () {
      this.resetFilterMutation()
      this.$emit('resetFilter')
    },
    setFilterEngravedId (value) {
      this.setFilterPair(buildFilterPair(FILTER_ENGRAVED_ID, value))
    },
    setFilterCardHolderDetails (value) {
      this.setFilterPair(buildFilterPair(FILTER_CARD_HOLDER_DETAILS, value))
    },
    setFilterCombinedAscriptions (value) {
      this.setFilterPair(buildFilterPair(FILTER_COMBINED_ASCRIPTIONS, value))
    }
  }
}
</script>

<style scoped>
  #filter {
    float: left;
    clear: none;
  }

  #resetFilter {
    float: right;
    clear: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/TerminateCardFilterForm.vue